/* Nividas Rx cart grouping — rx-spec-v3.md §8.

   "Group integrity via _rx_id.
      - Quantity change on any line in the group applies to every line
      - Removal of any line removes the whole group"

   Only the frame line renders quantity and remove controls (see
   cart-item.liquid); this script makes those act on every line sharing the
   same _rx_id. Handlers run in the capture phase so they take the event
   before the theme's own cart handlers see it.

   Works on both cart surfaces — the page and the drawer — because both
   render the same cart-item markup. */

(function () {
  'use strict';

  var CART_UPDATE = (window.theme && theme.routes && theme.routes.cartUpdate) || '/cart/update.js';

  function groupKeys(rxId) {
    var keys = [];
    document.querySelectorAll('.cart__item[data-rx-id]').forEach(function (el) {
      if (el.getAttribute('data-rx-id') === rxId) {
        var k = el.getAttribute('data-key');
        if (k && keys.indexOf(k) === -1) keys.push(k);
      }
    });
    return keys;
  }

  // One /cart/update.js call for the whole group. Using the updates map
  // rather than looping /cart/change.js keeps it to a single write, so the
  // group can never be left half-updated by a failed second request.
  function updateGroup(rxId, qty) {
    var keys = groupKeys(rxId);
    if (!keys.length) return Promise.resolve();

    var updates = {};
    keys.forEach(function (k) { updates[k] = qty; });

    return fetch(CART_UPDATE, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        // Ask the theme to re-render the cart rather than reloading — this
        // is the same event its own quantity widget fires.
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function (e) {
        console.error('[NV Rx] group cart update failed', e);
        // A failed group update leaves the cart in an unknown state; a
        // reload is the honest recovery rather than showing stale numbers.
        window.location.reload();
      });
  }

  // Shopify returns cart lines in its own order, which does not reliably put
  // the frame before the lens and add-on it was added with — in practice the
  // group renders reversed. Nesting only reads correctly if the frame comes
  // first, so the DOM is reordered after every render.
  function reorderGroups() {
    document.querySelectorAll('.cart__item[data-rx-role="frame"]').forEach(function (frame) {
      var rxId = frame.getAttribute('data-rx-id');
      if (!rxId) return;
      var anchor = frame;
      document.querySelectorAll('.cart__item[data-rx-role="child"]').forEach(function (child) {
        if (child.getAttribute('data-rx-id') !== rxId) return;
        if (child.parentNode !== frame.parentNode) return; // different surface
        // Move only when out of place. Re-inserting a line that is already
        // in position still counts as a DOM change, which the observer below
        // answers with another reorder — an endless loop (~120 moves/s while
        // the drawer was open, found 2026-10-15).
        if (anchor.nextElementSibling !== child) {
          anchor.insertAdjacentElement('afterend', child);
        }
        anchor = child;
      });
    });
  }

  // The cart re-renders on every quantity change and whenever the drawer
  // opens, so reordering has to run again each time rather than once.
  var reorderQueued = false;
  function queueReorder() {
    if (reorderQueued) return;
    reorderQueued = true;
    requestAnimationFrame(function () {
      reorderQueued = false;
      reorderGroups();
    });
  }

  document.addEventListener('cart:updated', queueReorder);
  document.addEventListener('cart:build', queueReorder);

  // Fallback for renders that do not fire a theme event — the drawer swaps
  // its markup wholesale, and not every path announces it.
  var mo = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.classList.contains('cart__item') || n.querySelector('.cart__item'))) {
          queueReorder();
          return;
        }
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reorderGroups);
  } else {
    reorderGroups();
  }

  function lineOf(el) {
    return el.closest ? el.closest('.cart__item[data-rx-id]') : null;
  }

  function currentQty(line) {
    var input = line.querySelector('.js-qty__num');
    var n = input ? parseInt(input.value, 10) : 1;
    return isNaN(n) ? 1 : n;
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var line = lineOf(target);
    if (!line) return;
    var rxId = line.getAttribute('data-rx-id');
    if (!rxId) return;

    // Removal — take the whole group with it.
    if (target.closest('.cart__remove a')) {
      e.preventDefault();
      e.stopPropagation();
      updateGroup(rxId, 0);
      return;
    }

    // Quantity steppers.
    var plus = target.closest('.js-qty__adjust--plus');
    var minus = target.closest('.js-qty__adjust--minus');
    if (plus || minus) {
      e.preventDefault();
      e.stopPropagation();
      var next = currentQty(line) + (plus ? 1 : -1);
      if (next < 0) next = 0;
      updateGroup(rxId, next);
    }
  }, true);

  // Typed quantity.
  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || !target.classList || !target.classList.contains('js-qty__num')) return;
    var line = lineOf(target);
    if (!line) return;
    var rxId = line.getAttribute('data-rx-id');
    if (!rxId) return;

    e.preventDefault();
    e.stopPropagation();
    var n = parseInt(target.value, 10);
    if (isNaN(n) || n < 0) n = 0;
    updateGroup(rxId, n);
  }, true);
})();
